module.exports = __webpack_public_path__ + "static/media/attachment_56777363-e1485987246720.8fb545ca.jpg";